<div *ngIf="interfaceService.isLeadsDomain && (authService.mode$ | async) == 'Аренда'; else content">
  <nz-alert class="mb-2" nzType="warning"
            nzMessage="Аренда аккаунтов временно приостановлена, можете уточнить в техподдержке статус этого вопроса. На вкладках рядом вы можете добавить аккаунт самостоятельно."
            nzShowIcon></nz-alert>
</div>
<ng-template #content>

  <div class="arendaLogin mb-2">
    <button (click)="arendSenderAccount();" [nzBlock]="true" nzSize="large" nzType="primary"
            class="effectMouse effect-white ant-btn-block"
            [nzLoading]="isLoading$ | async"
            (mousemove)="allService.effectMouseMove($event)" nz-button>
      {{(isLoading$ | async) ? 'Подождите...' : senderService.authTokens?.length > 0 ? 'Купить аккаунт' : 'Получить бесплатный аккаунт'}}
      <i-feather [style.margin-top.px]="-5" name="log-in"
                 class="ml-auto icon-md align-middle"></i-feather>
    </button>
    <div *ngIf="senderService.authTokens?.length == 0" class="mt-3 mb-5 text-right">
      <i-feather name="chevron-right" class="mr-2 icon-md text-primary text-underline"></i-feather>
      <a class="text-underline pointer text-muted"
         (click)="authService.mode$.next('Авторизация')"
      >Я уже регистрировался</a>
    </div>
  </div>

  <nz-alert class="mb-2" *ngIf="lastError" nzType="error"
            [nzMessage]="lastErrorMessage"
            nzShowIcon></nz-alert>
  <ng-template #lastErrorMessage>
    {{interfaceService.errorHandling(lastError, false) || 'Неопознаная ошибка, напишите нам или попробуйте чуть позже.'}}
    <a *ngIf="lastError?.error?.detail?.error_code === 'bad_balance'"
       (click)="modalService.openModal('ModalAddBalanceComponent')">пополнить</a>
  </ng-template>
  <nz-alert *ngIf="(authService.mode$ | async) == 'Аренда'" class="mb-2" nzType="success"
            nzMessage="С баланса спишется стоимость аккунта 100 ₽ единоразово + 1.5р за каждое сообщение с выданного аккаунта."
            nzShowIcon></nz-alert>

</ng-template>
